import { checkProductType } from '../utils/checkProductType';
import * as eventActions from '../actions/eventActions';
import { useTrackEventAnalyticsFromReducer } from 'srcAlias/client/global/customHooks/useTrackEventAnalytics';

import { get } from 'lodash-es';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === eventActions.PIGGYBANK_EVENT) {
    const formValues = get(action, 'event.values', '');
    const existingState = get(action, 'event.state', {});
    if (
      get(action, 'event.type') === 'onNavigate' &&
      get(action, 'event.component') === 'Wizard' &&
      get(action, 'event.currentPageName') === 'declaration'
    ) {
      const productCode = get(action, 'event.values.product', '');
      const {
        productDescription,
        productType,
        productDescriptionForAnalytics,
      } = productCode ? checkProductType(productCode) : {};
      const product = {
        productCode,
        productDescription,
        productDescriptionForAnalytics,
        productType,
      };
      const otherMarketsSelected =
        get(formValues, 'otherMarkets') === 'no' ? true : false;

      if (otherMarketsSelected) {
        useTrackEventAnalyticsFromReducer(
          'onChange',
          'otherMarketsYesNoButtonClick',
          {
            ...formValues,
          },
          {
            ...existingState,
            productSelection: {
              ...product,
            },
          }
        );
      }

      useTrackEventAnalyticsFromReducer(
        'onChange',
        'productSelectedOnContinueButton',
        {
          ...formValues,
        },
        {
          ...existingState,
          productSelection: {
            ...product,
          },
        }
      );

      useTrackEventAnalyticsFromReducer(
        'onClick',
        'continueButtonClickFromProductPage',
        {
          ...formValues,
        },
        {
          ...existingState,
          productSelection: {
            ...product,
          },
        }
      );

      return {};
    }
    if (get(action, 'event.type') === 'onError') {
      useTrackEventAnalyticsFromReducer(
        'onError',
        get(action, 'event.name'),
        {
          ...formValues,
        },
        {
          ...existingState,
        }
      );
    }

    return state;
  }
  return state;
};
